import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import BlackDuckCredentialsForm from './BlackDuckCredentialsForm';
import BlackDuckConfigListing from './BlackDuckConfigListing';

const BlackDuckPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={BlackDuckCredentialsForm}
        PullConfigListingView={BlackDuckConfigListing}
     />
);

export default BlackDuckPullAndPushView;
